// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__4csLu","content":"LoadingAlert_content__3Caqz"};